import { atom } from "recoil";

const airportState =atom({
    key: 'airport',
    default: 'Airport'
})

export default airportState